import { DefaultState } from 'store/reducers/types';

export const DOWNLOAD_JOB_LIST_EXCEL_REQUEST = 'DOWNLOAD_JOB_LIST_EXCEL_REQUEST';
export const DOWNLOAD_JOB_LIST_EXCEL_SUCCESS = 'DOWNLOAD_JOB_LIST_EXCEL_SUCCESS';
export const DOWNLOAD_JOB_LIST_EXCEL_FAILURE = 'DOWNLOAD_JOB_LIST_EXCEL_FAILURE';

export type JobListExcelState = DefaultState;

interface JobListExcelRequest {
  type: typeof DOWNLOAD_JOB_LIST_EXCEL_REQUEST;
};

interface JobListExcelSuccess {
  type: typeof DOWNLOAD_JOB_LIST_EXCEL_SUCCESS,
}

interface JobListExcelFailure {
  type: typeof DOWNLOAD_JOB_LIST_EXCEL_FAILURE;
}

export type JobListExcelActionTypes = JobListExcelRequest | JobListExcelSuccess | JobListExcelFailure;